import enTranslations from '../locales/en.json';
import nlTranslations from '../locales/nl.json';

type TranslationValue = string | string[] | Record<string, unknown>;
type TranslationObject = Record<string, TranslationValue>;
type Language = 'en' | 'nl';

const translations: Record<Language, TranslationObject> = {
  en: enTranslations,
  nl: nlTranslations,
} as const;

const resolve = (language: string, key: string): TranslationValue | undefined => {
  const currentTranslations =
    translations[language as Language] || translations.en;
  const keys = key.split('.');

  return keys.reduce<TranslationValue | undefined>(
    (acc, currentKey): TranslationValue | undefined => {
      if (
        acc &&
        typeof acc === 'object' &&
        !Array.isArray(acc) &&
        currentKey in acc
      ) {
        return acc[currentKey] as TranslationValue;
      }
      return undefined;
    },
    currentTranslations
  );
};

const getTranslation = (language: string, key: string): string => {
  const result = resolve(language, key);
  return typeof result === 'string' ? result : key;
};

const getTranslationArray = <T = string>(language: string, key: string): T[] => {
  const result = resolve(language, key);
  return Array.isArray(result) ? (result as T[]) : [];
};

export { translations, getTranslation, getTranslationArray };
export type { TranslationValue };
